'use strict';

import { Platform } from 'react-native';
function isWindowAvailable() {
  // the window object is unavailable when building the server portion of a site that uses SSG
  // this function shouldn't be used to conditionally render components
  // https://www.joshwcomeau.com/react/the-perils-of-rehydration/
  // @ts-ignore Fallback if `window` is undefined.
  return typeof window !== 'undefined';
}
export const IS_ANDROID = /* @__PURE__ */(() => Platform?.OS === 'android')();
export const IS_IOS = /* @__PURE__ */(() => Platform?.OS === 'ios')();
export const IS_WEB = Platform?.OS === 'web';
export const IS_JEST = typeof globalThis.jest !== 'undefined' || process.env.NODE_ENV === 'test';
/** @knipIgnore */
export const IS_WINDOWS = /* @__PURE__ */(() => Platform?.OS === 'windows')();
export const IS_WINDOW_AVAILABLE = isWindowAvailable();
//# sourceMappingURL=platform.js.map